import { render, staticRenderFns } from "./DistressalertsForm.vue?vue&type=template&id=6e4de3aa"
import script from "./DistressalertsForm.vue?vue&type=script&lang=js"
export * from "./DistressalertsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports